import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  APIProvider,
  ControlPosition,
  Map,
  Marker,
} from "@vis.gl/react-google-maps";

import { CustomMapControl } from "src/components/ui/Maps/MapControl";
import MapHandler from "src/components/ui/Maps/MapHandler";
import { White01 } from "src/styles/color";

const MapContainer = styled.div`
  /* height: 500px; */
  height: 100%;
  width: 100%;
  /* border: 2px solid black; */
  background-color: ${White01};
  border-radius: inherit;
  overflow: hidden;
`;

// shows marker on Xsurface by default
const DEFAULT_LOCATION = {
  lat: 13.6940782,
  lng: 100.6022862,
};

const CustomMap = ({
  markerLocation = DEFAULT_LOCATION,
  changeMarkerLocation,
  changeSeletedAddress, // optional: set address field when select on searched location
  inputPlaceholder = "",
  doNotCustom = false,
  isViewOnly = false, // if true, disabled map click
}) => {
  // add delay for set markered location before render component
  const [isRendering, setIsRendering] = useState(true);

  // center of map (same location of marker)
  const [defaultCenter, setDefaultCenter] = useState(DEFAULT_LOCATION);
  // store clicked location
  const [selectedLocation, setSelectedLocation] = useState(DEFAULT_LOCATION);
  // store search location
  const [selectedPlace, setSelectedPlace] = useState(null);

  useEffect(() => {
    if (!!markerLocation?.lat && !!markerLocation?.lng) {
      setSelectedLocation({
        lat: Number(markerLocation.lat),
        lng: Number(markerLocation.lng),
      });
      setDefaultCenter({
        lat: Number(markerLocation.lat),
        lng: Number(markerLocation.lng),
      });
      setIsRendering(false);
    }
  }, [markerLocation]);

  const handleMapClick = (mapProps) => {
    // checks if location clicked is valid
    const lat = mapProps.detail.latLng.lat;
    const lng = mapProps.detail.latLng.lng;

    setSelectedLocation({ lat, lng });
    changeMarkerLocation({ lat, lng });
  };

  const onSelectPlace = (placeDetail) => {
    if (!!placeDetail) {
      changeMarkerLocation({
        lat: placeDetail.geometry?.location?.lat(),
        lng: placeDetail.geometry?.location?.lng(),
      });
      setSelectedPlace(placeDetail);

      if (!!changeSeletedAddress) {
        changeSeletedAddress(placeDetail?.formatted_address);
      }
    }
  };

  return (
    <MapContainer>
      {!isRendering && (
        <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
          <Map
            defaultCenter={defaultCenter}
            // defaultCenter={DEFAULT_LOCATION}
            defaultZoom={16}
            disableDefaultUI
            gestureHandling={"cooperative"}
            onClick={(mapProps) => !isViewOnly && handleMapClick(mapProps)}
            style={{ borderRadius: "inherit" }}
          >
            <Marker position={selectedLocation} />
          </Map>

          {!doNotCustom && !isViewOnly && (
            <CustomMapControl
              controlPosition={ControlPosition.LEFT_TOP}
              onPlaceSelect={onSelectPlace}
              inputPlaceholder={inputPlaceholder}
            />
          )}

          <MapHandler place={selectedPlace} />
        </APIProvider>
      )}
    </MapContainer>
  );
};

export default CustomMap;
